import React, { useContext, useMemo } from "react"
import { CircularProgress, Grid, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { FilterVariantSelect } from "./components/FilterVariantSelect"
import { Variant1Context, Variant1ContextProvider } from "./contexts/Variant1Context"
import { Variant2Context, Variant2ContextProvider } from "./contexts/Variant2Context"
import { CompareVariantTopPanel } from "./components/CompareVariantTopPanel/CompareVariantTopPanel"
import { CompareVariantBottomPanel } from "./components/CompareVariantBottomPanel/CompareVariantBottomPanel"
import { ComparaisonModeContextProvider } from "./contexts/ComparaisonModeContext"
import { BSFilterContextProvider } from "../../../../../../components/charts/filters/BSFilterContext"
import { VariantListDashboardContext, VariantListDashboardContextProvider } from "./contexts/VariantListDashboardContext"

export function BSDashboardVariantCompare(): React.JSX.Element {
  return (
    <VariantListDashboardContextProvider>
      <Variant1ContextProvider>
        <Variant2ContextProvider>
          <BSDashboardVariantCompareCore1 />
        </Variant2ContextProvider>
      </Variant1ContextProvider>
    </VariantListDashboardContextProvider>
  )
}

function BSDashboardVariantCompareCore1(): React.JSX.Element {
  const { bsMaterialResultList1 } = useContext(Variant1Context)
  const { bsMaterialResultList2 } = useContext(Variant2Context)

  const allBSMaterialResult = useMemo(
    () => [...bsMaterialResultList1, ...bsMaterialResultList2],
    [bsMaterialResultList1, bsMaterialResultList2]
  )

  return (
    <BSFilterContextProvider allBSMaterialResult={allBSMaterialResult}>
      <BSDashboardVariantCompareCore2 />
    </BSFilterContextProvider>
  )
}
function BSDashboardVariantCompareCore2(): React.JSX.Element {
  const { bsVariants, isLoaded } = useContext(VariantListDashboardContext)

  const { variant1, selectVariant1 } = useContext(Variant1Context)
  const { variant2, selectVariant2 } = useContext(Variant2Context)

  if (bsVariants.length > 1) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        sx={{ userSelect: "none" }}>
        <Grid container columnSpacing={4} rowGap={4} sx={{ pt: 2 }}>
          {/* Top button */}
          <Grid item xs={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {variant1 && (
              <FilterVariantSelect
                id="variant1"
                label="Estimation 1"
                bsVariantList={bsVariants}
                selectedVariant={variant1}
                selectVariant={selectVariant1}
              />
            )}
          </Grid>
          <Grid item xs={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {variant2 && (
              <FilterVariantSelect
                id="variant2"
                label="Estimation 2"
                bsVariantList={bsVariants}
                selectedVariant={variant2}
                selectVariant={selectVariant2}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            <CompareVariantTopPanel />
          </Grid>
          <Grid item xs={12}>
            <ComparaisonModeContextProvider>
              <CompareVariantBottomPanel />
            </ComparaisonModeContextProvider>
          </Grid>
        </Grid>
      </Box>
    )
  } else if (!isLoaded) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress />
      </Box>
    )
  } else {
    return <Typography>Vous n'avez pas encore 2 estimations à comparer sur ce projet</Typography>
  }
}
